module.exports = __webpack_public_path__ + "static/img/news74_1.80b6e6c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/activity/news74/news74_1.webp
// module id = +QQp
// module chunks = 0